// Render Prop

import React, { Component, memo } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { EmployerApi } from "../../../util/api/EmployerApi";
import { Redirect } from 'react-router';

import { observer } from 'mobx-react';

import { FormGroup, Label, Input } from 'reactstrap';


import TableWidget from "../../widgets/TableWidget";


class SelectEmployer extends Component {
    static displayName = SelectEmployer.name;

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            selectedEmployer: false,
            filterText: ""
        };

        this.props.store.updateBanner("Update Employer");

        this.employerSelect = this.employerSelect.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.employerTable = this.employerTable.bind(this);
        this.handleSubmission = this.handleSubmission.bind(this);
    }

    handleSubmission(event) {
        const id = event.target.value;
        this.setState({ selectedEmployer: id })
    }


    render() {
        if (this.state.selectedEmployer == false) {
            return (
                <React.Fragment>
                    {this.employerSelect()}
                    {this.employerTable()}
                </React.Fragment>
            )
        }
        else {
            return <Redirect push to={"/staff/Employer/" + this.state.selectedEmployer} />
        }
    }

    async handleFilterChange(event) {
        await this.setState({ filterText: event.target.value });
    }

    employerSelect() {
        const employers = this.props.store.employers.collection;

        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    <Label for="employerFilter">Filter By Name</Label>
                    <Input placeHolder="Employer Name..." type="text" id="employerFilter" value={this.state.filterText} onChange={this.handleFilterChange} />
                </div>
            </div>
        )
    }

    employerTable() {
        const columns =
            [
                {
                    Header: "", accessor: "col1",
                    Cell: (props) => (
                        <button className="btn btn-light" value={props.cell.value} onClick={this.handleSubmission}>
                            Edit
                        </button>
                    ),
                    props: {
                        colspan: "1", style: { width: "10%", borderBottom: "3px solid white"  }
                    }
                },
                { Header: "Employer Name", accessor: "col2", props: { colspan: "1", style: {width: "25%"}} },
                { Header: "City, State", accessor: "col3", props: { colspan: "1", style: { width: "20%" }} },
                { Header: "Country", accessor: "col4", props: { colspan: "1", style: { width: "25%" } } },
                {
                    Header: "Accounts", accessor: "col5", props: { colspan: "1", style: { width: "10%", textAlign: "right" } },
                    Cell: (props) => (<div style={{ textAlign: "right" }}>{props.value}</div >)
                },
                {
                    Header: "Supervisors", accessor: "col6", props: { colspan: "1", style: { width: "10%", textAlign: "right" } },
                    Cell: (props) => (<div style={{ textAlign: "right" }}>{props.value}</div >)
                },
            ];

        let employers = this.props.store.employers.collection;



        employers = employers.filter(employer => {
            return employer.name.toLowerCase().includes(this.state.filterText.toLowerCase());
        })

        //Sort employers by name;
        employers.sort((employerA, employerB) => {
            const nameA = employerA.name.toLowerCase()
            const nameB = employerB.name.toLowerCase()

            if (nameA > nameB) {
                return 1
            }
            else if (nameA < nameB) {
                return -1
            }
            return 0
        });


        //We use memo to reduce recalculations. ;
        const data = employers.map(employer => {
            const supervisors = employer.supervisorIds.map(supervisorId => this.props.store.supervisors.getById(supervisorId).name).join(", ");
            const studentIds = employer.accountIds.map(accountId => this.props.store.accounts.getById(accountId).studentId);
            const students = studentIds.map(studentId => this.props.store.students.getById(studentId));
            const studentNames = students.map(student => student.firstName + " " + student.lastName).join(", ")
            console.log(studentNames)


            return {
                    col1: employer.id,
                    col2: employer.name,
                    col3: `${employer.city},  ${employer.state}`,
                    col4: employer.country,
                    col5: employer.accountIds.length,
                    col6: employer.supervisorIds.length,
                }
            }
        )

        return (
            <TableWidget
                tableProps={{ style: "mt-4" }}
                headerGroupProps={{ }}
                rowProps={{  }}
                columns={columns}
                data={data} />
        )
    }

}



SelectEmployer = observer(SelectEmployer);


export { SelectEmployer}